import React from 'react';
import classes from './CategoryIcon.module.css';

/* eslint-disable max-len */

const categoryIcon = () => {
  return (
    <svg className={[classes.OuterSVG, classes.type].join(' ')} width="22.085" height="21.151" viewBox="0 0 22.085 21.151">
      <g id="prefix__Group_3418" data-name="Group 3418" transform="translate(0 -4)">
        <g id="prefix__Group_3414" data-name="Group 3414" transform="translate(0 4)">
          <path id="prefix__Path_3745" d="M0 0v11" className={classes.CLS1} data-name="Path 3745" transform="translate(3.951 9.151)" />
          <path id="prefix__Path_3744" d="M0 0v11" className={classes.CLS1} data-name="Path 3744" transform="translate(11.852 9.151)" />
          <path id="prefix__Path_3743" d="M0 0v11" className={classes.CLS1} data-name="Path 3743" transform="translate(19.753 9.151)" />
          <path
            id="prefix__heart"
            d="M6.013 32.366a1.782 1.782 0 0 0-2.432.177l-.257.265-.257-.265a1.782 1.782 0 0 0-2.432-.177 1.872 1.872 0 0 0-.129 2.71l2.522 2.6a.409.409 0 0 0 .59 0l2.522-2.6a1.87 1.87 0 0 0-.127-2.71z"
            className={classes.CLS2}
            transform="translate(.012 -31.719)"
          />
          <path
            id="prefix__map-marker-alt"
            d="M2.058 5.992C.322 3.476 0 3.218 0 2.293a2.293 2.293 0 0 1 4.587 0c0 .925-.322 1.183-2.058 3.7a.287.287 0 0 1-.471-.001zm.236-2.743a.956.956 0 1 0-.956-.956.956.956 0 0 0 .955.956z"
            className={classes.CLS2}
            transform="translate(9.548)"
          />
          <path
            id="prefix__lightbulb"
            d="M1.147 5.426a.382.382 0 0 0 .064.211l.2.307a.382.382 0 0 0 .318.171h.737a.382.382 0 0 0 .318-.171l.2-.307a.382.382 0 0 0 .064-.211v-.458H1.147v.458zM0 2.1a2.091 2.091 0 0 0 .52 1.384 3.433 3.433 0 0 1 .624 1.092v.009h1.915v-.008a3.433 3.433 0 0 1 .624-1.092A2.1 2.1 0 1 0 0 2.1z"
            className={classes.CLS2}
            transform="translate(17.88 .001)"
          />
        </g>
      </g>
    </svg>
  );
};

export default categoryIcon;
